// Only clear the current view when we can positively confirm a UserPresenceChanged update is
// reporting THAT interaction's wrap-up ending. `wrapupMediaId` comes back empty whenever the update
// wasn't actually driven by a wrap-up transition — e.g. a plain messaging skip-wrap-up close
// recalculating the agent's availability (UpdateUserPresenceByUtilization never had a wrap-up to
// report). Treating a missing id as "must be about my current view" (a `wrapupMediaId &&`
// short-circuit) hid + force-refetched on EVERY interaction close for the agent, including
// background ones — for a moment the viewed interaction disappears and reappears, which remounts
// the workspace and wipes whatever the agent was typing (CC4ALL-9553).
export const shouldCancelActiveInteractionForWrapup = (
	wrapupMediaId: string | undefined,
	currentInteractionId: string | undefined
): boolean => !!wrapupMediaId && wrapupMediaId === currentInteractionId;
